#import "../fragments/source-basic.graphql"

query SourcesQuery($after: String) {
    sources(after: $after) {
        pageInfo {
            __typename
            endCursor
            hasNextPage
        }
        edges {
            node {
                ...SourceBasic
            }
        }
    }
}
